/* eslint-disable max-len */
import { useHistory } from 'react-router-dom';

import { useScreenSize } from '@/exceed';

export default () => {
  
  const screenSize = useScreenSize();

  const history = useHistory();

  const handleBrowse = () => history.push('/student/videos');

  return {
    screenSize,
    handleBrowse,
  };
};
